/**
 * The feature toggle that switches Easy Quote on, read by `pages/easy-quote/index.tsx` through
 * `components/NextLayouts/PublicWithFeature.tsx`. The same key gates the store's Easy Quote pages
 * (`web-store-ui/application/src/components/EasyQuote/Helper/PageSupport/EasyQuote.constants.ts`)
 * and the session route (`web-quotes-api/application/src/enums/featureToggle.enum.ts` →
 * `QuoteFeatureToggle.EASY_QUOTE`, which answers 404 while it is off). Rename it in all three.
 */
export const EasyQuoteFeatureFlag = "10051-easy-quote";
